import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import '../css/App.css';
import '../css/additional-styles/Responsive.css';
import Sidebar from '../partials/Sidebar';
import Header from '../partials/Header';
import Banner from '../partials/Banner';
import BasicCalendar from '../components/ui/MyCalendar';

function Dashboard() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (decoded?.role === 'Marketing monitor') {
          navigate('/marketing/consent', { replace: true });
        }
      } catch (e) {
        console.error(e);
      }
    }
  }, [navigate]);

  return (
    <div className="flex h-screen overflow-auto pb-safe-bottom pt-safe-top">
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="relative flex flex-col min-h-screen-mobile flex-1 overflow-y-auto overflow-x-hidden min-h-0">
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <main className="flex flex-col flex-1 min-h-0">
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl xs:max-w-screen-xl mx-auto max-w-md md:max-w-2xl">
            <div className="sm:flex-row sm:justify-between sm:items-center mb-8">
              <div className="mb-4 sm:mb-0">
                <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">Dashboard</h1>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-6 ">

            </div>
            <BasicCalendar className={" col-span-full h-full rounded-lg border sm:flex-row"} />
          </div>
        </main>
        <Banner />
      </div>
    </div>
  );
}

export default Dashboard;